module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAABIElEQVQ4T+2TvyvEYRzHX5+vX0mJUVmubMhgkwv17ZvJYLksysDT2S3+AIvdOQZlugwGk759RXe6TUlsyqKsl5Kc7vmIAfG4712uzuBZnuF5nlevz/N5f4QGL2kwjyYAs34a2ACWMVEmrqJ4w3/gH/nDralBlo6v3mxcTckEQ6TDS5etu8tZ/xavnGQxf/MNuB0ksLaAifrrASpwjafjWJl9z6Gn+1g5BQYwkVPGbbjp5xBSwDmie6isIbqKJYXICGgOczRXh+FoG/QeANOoPiLS+Wk/REozmLPn2oGvN9eDLrorIcjYx0Mtct8SsBI+/BSf6qO3M9lDuTUPDINe0F6ZYOGkVC2LNcxysg86duFpHlO4+32w4whfzuMNmw18Af8wahVuQMIyAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/image/index/xia-index.png
// module id = VxKg
// module chunks = 1